import {defineSlotRecipe} from '@chakra-ui/react3'

/**
 * recipe for Teaser:
 * slots: root, headline,
 * variants:
 *  - teaserBackground: true | false
 */

export default defineSlotRecipe({
    slots: [
        'root',
        'imageContainer',
        'iconButton',
        'container',
        'textContainer',
        'headline',
        'copy'
    ],
    base: {
        root: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: 'spacing-24',
            borderRadius: 's'
        },
        imageContainer: {
            borderTopRightRadius: 's',
            borderTopLeftRadius: 's',
            position: 'relative'
        },
        iconButton: {
            position: 'absolute',
            bottom: 'spacing-16',
            right: 'spacing-16',
            zIndex: 'overlay'
        },
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'spacing-24'
        },
        textContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'spacing-8'
        },
        headline: {color: 'text.primary', textStyle: 'heading.large'},
        copy: {color: 'text.secondary', textStyle: 'body.small', alignment: 'left'}
    },
    variants: {
        teaserBackground: {
            true: {
                root: {
                    backgroundColor: 'var(--module-surface-bg-color)'
                },
                container: {paddingX: 'spacing-24', paddingBottom: 'spacing-24'}
            },
            false: {
                imageContainer: {borderBottomRightRadius: 's', borderBottomLeftRadius: 's'},
                textContainer: {
                    paddingRight: 'spacing-16'
                }
            }
        },
        textSpacing: {
            carousel: {
                textContainer: {
                    paddingRight: 'spacing-40'
                }
            }
        }
    }
})
